import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { environment as env } from '../../environments/environment';

@Component({
  selector: 'orchestra-login',
  templateUrl: './orchestra-login.component.html',
  styleUrls: ['./orchestra-login.component.scss']
})
export class OrchestraLoginComponent implements OnInit {
  user: string;
  password: string;
  @ViewChild("txtUser") txtUser: ElementRef;
  @ViewChild("group") validation:DxValidationGroupComponent;

  constructor(
    private router: Router,
    private auth: AuthService,
    private global: GlobalService,
    private zone:NgZone
    ) {
    this.auth.isTopbarVisible = false;
    this.auth.isSidebarVisible = false;
    this.auth.isSidebarOpened = false;
    this.auth.minSidebarSize = 0;
  }


  ngOnInit() {
    this.auth.isTopbarVisible = false;
    if(this.auth.getCookie("token")!=null){
      this.navigateToHome();
    }
  }

  authenticate(){
    let redirect = "https://accounts.google.com/o/oauth2/v2/auth?" +
      "scope=" + env["scope"] + "&" +
      "response_type=code&" +
      "access_type=offline&"+
      "state=orchestratoken&" +
      "redirect_uri=" + env["loginUrl"] + "/google-login&" +
      "client_id=" + env["clientId"] +"&"+
      "prompt=consent";

    this.popupCenter({ url: redirect, title: "Sign In with Google", w: 400, h: screen.availHeight - 20 });
  }

  isAuthenticated(){
    let oauth = this.auth.getCookie('oauth');
    if(oauth!=undefined){
      this.global.toggleBlockUI();
      this.auth.loginByEmail(oauth).then(res=>{
        this.global.toggleBlockUI();
        if (res) {
          if (String(this.auth.user.lastLoginTimestamp) == "1970-01-01T00:00:00") {
            localStorage.setItem('auth.changepassword', 'YES');
          }
          this.global.showSuccessDialog("Berhasil login sebagai " + this.auth.user.fullName);
          this.zone.run(()=>{
            this.navigateToHome();
          });
        }
      }).catch(error=>{
        this.global.showErrorDialog(error);
      });
    }else{
      this.global.showErrorDialog("Failed to login with google.");
    }
  }

  popupCenter = ({ url, title, w, h }) => {
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    const newWindow = window.open(url, title,
      `
      scrollbars=yes,
      width=${(screen.width / 3)},
      height=${(screen.height*2/3)},
      top=${top},
      left=${left},
      resizable=yes,
      toolbar=no,
      menubar=no,
      location=no,
      directories=no,
      status=yes
      `
    )

    var timer = setInterval(()=> {
      if (newWindow.closed) {
        clearInterval(timer);
        this.isAuthenticated();
      }
    }, 1000);

    if (window.focus) newWindow.focus();
    return newWindow;
  }

  navigateToHome(){
    this.auth.isTopbarVisible = true;
    if (!this.auth.redirectUrl || this.auth.redirectUrl == '/login') this.auth.redirectUrl = '/';
    console.log(this.auth.redirectUrl);
    this.auth.goToRedirect();
  }

  login() {
    //alert(this.user||" + "||this.password);
    if (!this.validation.instance.validate().isValid) {
      return;
    }
    this.global.blockUI = true;
    this.auth.login(this.user, this.password).then(result => {
      console.log(result);
      this.global.blockUI = false;
      if (result) {
        if (String(this.auth.user.lastLoginTimestamp) == "1970-01-01T00:00:00") {
          localStorage.setItem('auth.changepassword', 'YES');
        }
        this.validation.instance.reset();
        this.global.showSuccessDialog("Berhasil login sebagai "+this.auth.user.fullName);
        this.navigateToHome();
      }
      else {
        this.global.showErrorDialog('User atau password anda salah!');
      }
    }).catch(err=>{
      this.global.blockUI = false;
      if(err.status==401){
        this.global.showErrorDialog('User atau password anda salah!');
      }else if(err.message){
        this.global.showErrorDialog(err.message);
      }else{
        this.global.showErrorDialog(err);
      }
    });
  }
}
